module.exports = __webpack_public_path__ + "img/cloudgo_logo.477d9adc.png";